<template>
  <div v-if="!hideAddFiles || !hideAddNotes">
    <div class="flex" :class="wrapperClass">
      <q-input
        v-if="!hideAddNotes && simpleNote"
        ref="simpleNoteField"
        v-model="newNote.value"
        outlined
        dense
        placeholder="Add Note..."
        color="green-7"
        class="flex-auto"
        :disable="disable || newNote.loading"
        :loading="newNote.loading"
        @keyup.enter="addNote"
      >
        <template v-if="stripHtml(newNote.value || '').length > 0" #append>
          <q-btn
            v-if="!newNote.loading"
            dense
            flat
            round
            icon="mdi-plus"
            color="green-7"
            :disable="newNote.loading"
            @click="addNote"
          >
            <q-tooltip>Add Note</q-tooltip>
          </q-btn>
        </template>
      </q-input>
      <q-btn
        v-if="!hideAddNotes && !simpleNote"
        label="New Note"
        icon-right="mdi-plus"
        size="12px"
        color="green-7"
        padding="sm md"
        :disable="disable"
        @click="newNote.dialog = true"
      />
      <q-btn
        v-if="!hideAddFiles"
        label="Attach File"
        icon-right="mdi-plus"
        size="12px"
        color="blue-7"
        padding="sm md"
        :disable="disable"
        @click="$refs.fileSelectDialog.open()"
      />
      <slot />
    </div>
    <q-separator v-if="!hideSeparator" />

    <!-- Add Note -->
    <content-dialog
      v-if="!hideAddNotes"
      v-model="newNote.dialog"
      :loading="newNote.loading"
      no-backdrop-dismiss
      fullscreen-mobile
      title="New Note"
      width="750px"
      @hide="resetNote"
    >
      <text-editor
        v-model="newNote.value"
        class="q-pa-xs"
        autofocus
      />
      <template #bottom>
        <q-toolbar>
          <q-space />
          <q-btn
            label="Save"
            color="green"
            icon-right="done"
            :disable="stripHtml(newNote.value || '').length < 1"
            :loading="newNote.loading"
            @click="addNote"
          />
        </q-toolbar>
      </template>
    </content-dialog>

    <!-- Select Files -->
    <file-select-dialog
      v-if="!hideAddFiles"
      ref="fileSelectDialog"
      :selected="fileEntries"
      :maximum="0"
      @saved="saveAttachments"
    />
  </div>
</template>

<script>
function defaultNewNote () {
  return {
    dialog: false,
    loading: false,
    value: null
  }
}

export default {
  props: {
    hideAddFiles: {
      type: Boolean,
      default: false
    },
    hideAddNotes: {
      type: Boolean,
      default: false
    },
    hideSeparator: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    simpleNote: {
      type: Boolean,
      default: false
    },
    fileEntries: {
      type: Array,
      default: () => {
        return []
      }
    },
    wrapperClass: {
      type: [String, Object],
      default: 'q-gutter-sm'
    }
  },
  emits: ['addNote', 'saveAttachments'],
  data () {
    return {
      newNote: defaultNewNote()
    }
  },
  methods: {
    focusOnNewNote () {
      if (!this.hideAddNotes && this.simpleNote) {
        this.$refs.simpleNoteField.focus()
      }
      else if (!this.hideAddNotes) {
        this.newNote.dialog = true
      }
    },
    // Reset Add Note dialog
    resetNote () {
      this.newNote = defaultNewNote()
    },
    // Submit new note
    addNote () {
      if (this.newNote.loading || this.stripHtml(this.newNote.value || '').length < 1) { return }

      this.newNote.loading = true
      this.$emit('addNote', this.newNote, () => {
        this.resetNote()
        this.$q.notify({
          color: 'green',
          message: 'Note added'
        })
        if (this.$refs.simpleNoteField) {
          this.$refs.simpleNoteField.blur()
        }
      })
    },
    // Submit attachments which have been saved to the timeline
    saveAttachments (files) {
      const fileIdsToUse = files.map(item => item.id)
      const filesToRemove = this.fileEntries.filter(item => !fileIdsToUse.includes(item.id))

      // Separate payloads for handling adding and removing files from this timeline
      this.$emit('saveAttachments', fileIdsToUse, filesToRemove, () => {
        this.$q.notify({
          color: 'green',
          message: 'Attachments saved'
        })
      })
    }
  }
}
</script>
